import { styled } from '@mui/material/styles';
import React from 'react';
import PropTypes from 'prop-types';

const MAX_PROGRESS = 92;

const StyledLoading = styled('div')(({ theme }) => ({
  position: 'fixed',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  color: (theme.vars || theme).palette.text.primary,
  pointerEvents: 'none',
  zIndex: theme.zIndex.tooltip + 1,
  '.loading-label': {
    position: 'absolute',
    bottom: theme.spacing(1.5),
    right: theme.spacing(1.5),
    display: 'flex',
    gap: theme.spacing(0.75),
    alignItems: 'baseline',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: (theme.vars || theme).palette.background.paper,
    boxShadow: theme.shadows[2],
    padding: theme.spacing(0.4, 0.75),
    fontSize: '0.75rem',
    fontVariantNumeric: 'tabular-nums',
  },
  '.loading-track': {
    height: 3,
    overflow: 'hidden',
    backgroundColor: (theme.vars || theme).palette.action.disabledBackground,
  },
  '.loading-progress': {
    height: '100%',
    backgroundColor: (theme.vars || theme).palette.brand.main,
    boxShadow: `0 0 8px ${(theme.vars || theme).palette.brand.main}`,
    transition: 'width 160ms ease-out',
  },
  '.visually-hidden': {
    position: 'absolute',
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: 'hidden',
    clip: 'rect(0 0 0 0)',
    whiteSpace: 'nowrap',
    border: 0,
  },
}));

const Loading = ({ label = 'Inhalt wird geladen' }) => {
  const [progress, setProgress] = React.useState(8);

  React.useEffect(() => {
    const interval = window.setInterval(() => {
      setProgress((currentProgress) => {
        const step = Math.max(1, Math.round((MAX_PROGRESS - currentProgress) * 0.12));
        return Math.min(MAX_PROGRESS, currentProgress + step);
      });
    }, 160);

    return () => window.clearInterval(interval);
  }, []);

  return (
    <StyledLoading>
      <div className="loading-label" aria-hidden="true">
        <span>{label}</span>
        <span>{progress} %</span>
      </div>
      <div
        className="loading-track"
        role="progressbar"
        aria-label={label}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={progress}
      >
        <div className="loading-progress" style={{ width: `${progress}%` }} />
      </div>
      <span className="visually-hidden" role="status">{label}</span>
    </StyledLoading>
  );
};

Loading.propTypes = {
  label: PropTypes.string,
};

export default Loading;
